import { useMutation } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useChangeWorksheetStatus = () => {
  return useMutation((data) => {
    return axiosPost("/api/cw/workSheetStatusChange", data);
  });
};

export default useChangeWorksheetStatus;
